import type { ColorFamily } from '@repo/api-contracts';
import type { CSSProperties } from 'react';

/** 스와치 표시 전용 대표색 — 실제 상품 색상은 상세의 colorCode 가 결정한다. */
export const COLOR_FAMILY_SWATCH_STYLES: Readonly<Record<ColorFamily, CSSProperties>> = {
  BLACK: { backgroundColor: '#000000' },
  WHITE: { backgroundColor: '#ffffff' },
  GRAY: { backgroundColor: '#9ca3af' },
  RED: { backgroundColor: '#ef4444' },
  ORANGE: { backgroundColor: '#f97316' },
  YELLOW: { backgroundColor: '#eab308' },
  GREEN: { backgroundColor: '#22c55e' },
  BLUE: { backgroundColor: '#3b82f6' },
  PURPLE: { backgroundColor: '#a855f7' },
  PINK: { backgroundColor: '#ec4899' },
  BROWN: { backgroundColor: '#92400e' },
  BEIGE: { backgroundColor: '#d6c7a1' },
  MULTI: { background: 'conic-gradient(#ef4444, #eab308, #22c55e, #3b82f6, #a855f7, #ef4444)' },
};
